/**
 * Application level loader. Denotes loading status of all ApplicationWrapper
 * level contexts/elements. True means everything has been loaded, false means
 * at least one of the contexts is still loading. Currently only accounts for
 * SiteConfig and Auth0 loading statuses.
 */
export type LoadingType = boolean;
